import { ClipboardList, CheckCircle2, Hourglass } from 'lucide-react'
import type { ShiftKpis } from '../types/shift.types'

interface ShiftKpiCardsProps {
  kpis: ShiftKpis
}

export function ShiftKpiCards({ kpis }: ShiftKpiCardsProps): JSX.Element {
  const cards = [
    { label: 'Total Incidents', value: kpis.total, sub: 'This shift', Icon: ClipboardList, color: 'text-blue-500' },
    { label: 'Resolved Incidents', value: kpis.resolved, sub: `${kpis.efficiencyPct}% Efficiency`, Icon: CheckCircle2, color: 'text-green-500' },
    { label: 'Pending', value: kpis.pending, sub: 'In progress / new / acknowledged', Icon: Hourglass, color: 'text-red-500' },
  ]
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {cards.map((c) => (
        <div key={c.label} className="rounded-xl border border-gray-200 bg-white p-4">
          <div className="flex items-center gap-2">
            <c.Icon className={`h-5 w-5 ${c.color}`} />
            <p className="text-sm text-gray-500">{c.label}</p>
          </div>
          <p className="mt-2 text-2xl font-bold leading-tight text-gray-900">{c.value}</p>
          <p className="text-xs text-gray-400">{c.sub}</p>
        </div>
      ))}
    </div>
  )
}
